import { Link } from "react-router-dom";

export function Logo({ compact = false, light = false, className = "" }) {
  return (
    <Link to="/" data-testid="site-logo" className={`group flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo-mark.png"
        alt="ISMO-TECH"
        width="72"
        height="50"
        className="h-9 w-auto shrink-0 transition-transform duration-300 group-hover:scale-105 sm:h-11"
        style={{ filter: "drop-shadow(0 4px 10px rgba(0,82,255,0.18))" }}
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-ink"}`}
        >
          ISMO<span className="text-brand">-TECH</span>
        </span>
        {!compact && (
          <span className="mt-0.5 text-[9px] font-bold uppercase tracking-[0.22em] text-slate-400">
            Multiples Services Informatiques
          </span>
        )}
      </span>
    </Link>
  );
}

export default Logo;
